<template>
	
	<div class="content-area__inner content-area__timebook">
		
		<!-- Page Title -->
		
		<ContentAreaTitle :title="$route.meta.title"/>
		
		<!-- Manual Entry -->
		
		<legend class="content-area__element-title">Manual Entry</legend>
		
		<div class="card card--shadow card--no-padding" style="margin-bottom: 20px;">
			<TimeBookManualEntry ref="timeBookManualEntry" @on-add="onAddTimeBookEntry"></TimeBookManualEntry>
		</div>
		
		<!-- List -->
		
		<TimeBookList ref="timeBookList"/>
		
	</div>
	
</template>

<script>
	
	import ContentAreaTitle from "@/components/ContentAreaTitle";
	
	import TimeBookManualEntry from "./ManualEntry";
	import TimeBookList from "./List";
	
	export default {
		
		name: "TimeBook",
		
		components: { ContentAreaTitle, TimeBookManualEntry, TimeBookList },
		
		methods: {
			
			onAddTimeBookEntry(response) {
				this.$refs.timeBookList.refresh();
			},
			
		}
		
	}
	
</script>

<style lang="scss" scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/TimeBook/TimeBook.vue